module.exports = __webpack_public_path__ + "img/motsu_teisyoku.9098fda3.jpg";